import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_APARTMENT_BUILDING_GET_BY_ID,
} from 'api/actionTypes';

export default async function getById(
  { state, apiClient },
  { apartmentBuildingId, forceRefresh },
) {
  typeCheck('apartmentBuildingId::Number', apartmentBuildingId);

  const apartmentStatePath = ['apartments', 'apartmentBuildingsById', apartmentBuildingId];
  if (state.get(apartmentStatePath) && !forceRefresh) {
    return state.get(apartmentStatePath);
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_APARTMENT_BUILDING_GET_BY_ID,
    state: state,
    payload: {
      apartmentBuildingId: apartmentBuildingId,
    },
    onSuccess(apartmentBuilding) {
      if (apartmentBuilding) {
        state.set(apartmentStatePath, apartmentBuilding);
      }
    },
  });
}
